import React, { memo } from 'react';
import {
  Box,
  Typography,
  IconButton,
  Tooltip,
  CircularProgress,
} from '@material-ui/core';
import { ChatBubbleOutline, DeleteOutline } from '@material-ui/icons';

const SidebarSessionList = ({
  sessions,
  loadingKey,
  projectSessionsLoadingKey,
  currentChatId,
  loadingChatId,
  deletingChatId,
  isDarkMode,
  onLoadChat,
  onDeleteChat,
}) => {
  const list = sessions || [];
  const isLoading = projectSessionsLoadingKey === loadingKey && list.length === 0;

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 1.5, pl: 2 }}>
        <CircularProgress size={18} />
      </Box>
    );
  }

  if (!list.length) {
    return (
      <Typography sx={{ color: 'gray', px: 2.5, py: 1, fontSize: '0.78rem' }}>
        No chats yet
      </Typography>
    );
  }

  return list.map((item) => (
    <Box
      key={item.id}
      onClick={() => onLoadChat(item)}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        pl: 3.5,
        pr: 0.5,
        py: 0.85,
        borderRadius: '10px',
        cursor: 'pointer',
        transition: 'all 0.15s',
        color: isDarkMode ? 'rgba(255,255,255,0.9)' : 'rgba(0,0,0,0.8)',
        bgcolor:
          currentChatId === item.id
            ? isDarkMode
              ? 'rgba(255,255,255,0.06)'
              : 'rgba(0,0,0,0.04)'
            : 'transparent',
        '&:hover': {
          bgcolor: isDarkMode ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.04)',
        },
        '&:hover .chat-delete-btn': { opacity: 1 },
      }}
    >
      <ChatBubbleOutline
        sx={{
          fontSize: 16,
          color: isDarkMode ? 'rgba(255,255,255,0.45)' : 'rgba(0,0,0,0.3)',
        }}
      />
      <Typography
        sx={{
          fontSize: '0.82rem',
          fontWeight: 500,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          flex: 1,
          minWidth: 0,
        }}
      >
        {item.title}
      </Typography>
      {loadingChatId === item.id && (
        <CircularProgress size={12} sx={{ flexShrink: 0 }} />
      )}
      <Tooltip title="Delete chat" arrow>
        <span>
          <IconButton
            className="chat-delete-btn"
            size="small"
            onClick={(e) => onDeleteChat(e, item)}
            disabled={deletingChatId === item.id}
            sx={{
              opacity: 0.35,
              transition: 'opacity 0.15s',
              p: 0.35,
              flexShrink: 0,
              color: isDarkMode ? 'rgba(255,255,255,0.45)' : 'rgba(0,0,0,0.35)',
              '&:hover': { color: '#e57373', bgcolor: 'transparent' },
            }}
          >
            {deletingChatId === item.id ? (
              <CircularProgress size={14} />
            ) : (
              <DeleteOutline sx={{ fontSize: 16 }} />
            )}
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  ));
};

export default memo(SidebarSessionList);
